const coreCardTypesMixins = {
  getCoreCardIcon(type) {
    switch (this.$vuetify.lang.current) {
      case "table_group":
        switch (type.id) {
          case this.$enums.coreCardTypes.TEAM_COHESION:
          case this.$enums.coreCardTypes.IDEAL_TEAM_PLAYER:
          case this.$enums.coreCardTypes.STRATEGIC_ANCHORS:
            return this.$images.TABLE_GROUP_DARK_ICON;
        }
    }
    return "";
  },
  getCoreCardSort(type) {
    let isTableGroup = this.$vuetify.lang.current == "table_group";
    switch (type.id) {
      case this.$enums.coreCardTypes.OVERALL:
        return 40;
      case this.$enums.coreCardTypes.TEAM_COHESION:
        return isTableGroup ? 10 : 71;
      case this.$enums.coreCardTypes.STRATEGIC_ANCHORS:
        return isTableGroup ? 20 : 72;
      case this.$enums.coreCardTypes.MISSION_VALUE:
        return 60;
      case this.$enums.coreCardTypes.PULSE:
        return 50;
      case this.$enums.coreCardTypes.ENPS:
        return 80;
      case this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK:
      case this.$enums.coreCardTypes.HIGH_LOW:
        return 75;
      case this.$enums.coreCardTypes.ENGAGEMENT:
        return 90;
      case this.$enums.coreCardTypes.IDEAL_TEAM_PLAYER:
        return 30;
      case this.$enums.coreCardTypes.REVIEW:
        return 90;
      case this.$enums.coreCardTypes.MANAGER_SCORE:
        return 100;
      case this.$enums.coreCardTypes.RECOGNITION:
        return 70;
      case this.$enums.coreCardTypes.GOAL:
        return 120;
      case this.$enums.coreCardTypes.ACTION_ITEM:
        return 130;
      default:
        if (type.isPulse) {
          return 71;
        } else if (type.isReview) {
          return 91;
        }
        return 200;
    }
  },
  getCoreCardVisible(type) {
    switch (type.id) {
      case this.$enums.coreCardTypes.OVERALL:
        if (
          !this.core_value &&
          ((this.company && this.settings.isPulseActive) ||
            (!this.company && this.settings.isReviewActive))
        ) {
          return true;
        }
        break;
      case this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK:
      case this.$enums.coreCardTypes.HIGH_LOW:
        return !!this.company;
      case this.$enums.coreCardTypes.ENGAGEMENT:
        if (!this.core_value) {
          return true;
        }
        break;
      case this.$enums.coreCardTypes.RECOGNITION:
        return true;
      case this.$enums.coreCardTypes.GOAL:
        if (!this.core_value) {
          return true;
        }
        break;
      case this.$enums.coreCardTypes.ACTION_ITEM:
        if (this.user) {
          return true;
        }
        break;
      case this.$enums.coreCardTypes.MANAGER_SCORE:
        if (!this.core_value && (!this.user || this.user.isManager)) {
          return true;
        }
        break;
      default:
        if (type.isPulse && !this.core_value && !this.user && !this.manager) {
          return true;
        } else if (type.isReview && !this.core_value) {
          return true;
        }
    }
    return false;
  }
};

export default { methods: coreCardTypesMixins };
